import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const ElevatorIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"elevator"} ref={ref}/>
});

ElevatorIcon.displayName = "ElevatorIcon";
